import dynamic from "next/dynamic";
import React from "react";
import Link from "next/link";
import { getAssets } from "@unisearch/helpers";
import styles from "./blog_list_box.module.scss";
import { excerpt } from "@unisearch/helpers/utils";

import PlayButtonWithRipple from "@modules/study/common/play_btn_with_ripple";
import Image from "next/image";
// import SocialSharingLinks from "";
const SocialSharingLinks = dynamic(
  () => import("@modules/study/common/social_sharing_links"),
  {
    ssr: false,
  }
);
const baseUrl = process.env.NEXT_PUBLIC_URL;

const BlogListBox = ({
  blogTitle,
  blogLink,
  categories,
  featureImage,
  blogContent,
  videoType,
}) => {
  return (
    <div className={styles.blog_list}>
      <div className={`${styles.blog_thumb} relative`}>
        <Link href={blogLink || "#"}>
          <Image
            alt={blogTitle}
            width={500}
            height={400}
            src={
              featureImage ||
              getAssets("assets/images/image_placeholder_big.webp")
            }
            blurDataURL={getAssets(
              "assets/images/study/country_placeholder.webp"
            )}
            placeholder="blur"
          />
          {videoType && (
            <Link href={blogLink}>
              <PlayButtonWithRipple medium ripple={false} />
            </Link>
          )}
        </Link>
      </div>

      <div className={styles.blog_content}>
        {categories && categories?.length > 0 && (
          <div className={styles.blog_cat}>
            <div className={styles.post_cat_list}>
              {categories?.map((cat, i, row) => {
                return (
                  <a
                    key={`cat${i}`}
                    href={`/blog/category/${cat?.slug}?page=1`}
                  >
                    {cat?.title}
                    {row.length === ++i ? null : ", "}
                  </a>
                );
              })}
            </div>
          </div>
        )}

        <h4 className={`${styles.blog_title} !mt-1`}>
          <Link href={blogLink || "#"} className="block leading-[30px]">
            {blogTitle}
          </Link>
        </h4>

        <div className="line-clamp-2 text-sm leading-[1.8] mb-[10px]">
          <Link href={blogLink || "#"}>{excerpt(blogContent, 400)}</Link>
        </div>

        <div className={styles.blog_foot}>
          <div className={styles.view_more}>
            <Link legacyBehavior href={blogLink}>
              <a>Read More</a>
            </Link>
          </div>
          <div className={styles.social_share}>
            <SocialSharingLinks
              url={`${baseUrl}${blogLink}`}
              title={blogTitle}
              className={styles.social_link}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogListBox;
